const SITE_HOST_NAME = 'https://signalstickers.com';
const MAXIMUM_IMAGE_NUMBER = 150;
const SEO_TITLE = 'Signal Sticker Maker - Make your own stickers';
const SEO_TYPE = 'website';
const SEO_DESCRIPTION = 'Free Signal sticker maker - Create custom stickers for Signal messaging app in minutes';
const SEO_NAME = 'SignalStickerMaker';
export { 
  SITE_HOST_NAME,
  MAXIMUM_IMAGE_NUMBER,
  SEO_TITLE,
  SEO_TYPE,
  SEO_DESCRIPTION,
  SEO_NAME,
};